import { PolymorphicElement } from "../../primitive";
import cx from "classnames";
import css from "./Typography.module.css";

export interface TypographyProps {
  as?:
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "b"
    | "blockquote"
    | "code"
    | "p"
    | "span"
    | "strong";
  children: JSX.Element | JSX.Element[] | string;
  className?: string;
}

const BASE_CLASS = "f-Typography";

export const Typography = ({
  as = "h1",
  className,
  ...restProps
}: TypographyProps) => {
  const classNames = cx(`${css[BASE_CLASS]}`, {
    [`${className}`]: Boolean(className),
  });
  return <PolymorphicElement as={as} className={classNames} {...restProps} />;
};
